<template>
  <div id="app">
    	<router-view></router-view>
  </div>
</template>
 
<script>
import Vue from 'vue'
import ElementUI from 'element-ui'
Vue.use(ElementUI)
export default {
  name: 'async',
	metaInfo () {
		return {
			meta: [
        {
          name: 'keyWords',
          content: this.$t('meta.keyWords')
        },
        {
          name: 'description',
          content: this.$t('meta.description')
        }
      ]
		}
	},
	data(){
		return{
			
		}
	},
  methods: {
  }
}
</script>




// WEBPACK FOOTER //
// src/App.vue